import type { AdCreative, OfferTemplate } from "@b2bportal/media-ads-api";
import { OfferDiscountEnum } from "@b2bportal/media-ads-api";
import type { OfferTileProperties } from "@/tracking/events/raw/OfferRawEvent";
import { OfferType } from "@/tracking/offers";

/** Amplitude tile properties for a sponsored offer; the creative wins when the ad is known. */
export const getOfferTileTrackingProperties = ({
  offer,
  creative,
  countryName,
  tileIndex,
}: {
  offer: OfferTemplate;
  creative?: AdCreative;
  countryName?: string;
  tileIndex: number;
}): OfferTileProperties => ({
  offer_type: OfferType.hts_media,
  offer_id: offer.offerTemplateId,
  offer_name: offer.name,
  destination:
    creative?.destinationName ??
    offer.targetProduct?.productIdentifierValue ??
    "",
  destination_label:
    creative?.destinationName ??
    offer.targetProduct?.searchTerm ??
    offer.assets.title,
  destination_country_code: countryName ?? "",
  tile_index: tileIndex,
  discount_percentage:
    offer.discount?.OfferDiscount === OfferDiscountEnum.Percentage
      ? offer.discount.discountPercent
      : 0,
});
